export default "__VITE_ASSET__DFAOOEP3__"